export default __webpack_public_path__ + "static/media/about-city-right.4ffb4525.png";